import { Type } from '@angular/core';
import { IAction } from './action';

/**
 * The default action creator for dispatching actions
 * @param action the action you want to dispatch
 * @param sender the class where the action gets dispatched from
 * @description devtools will show the name of the sender on the action
 * that is dispatched
 */
export const createAction = <T>(action: IAction, { name = null }: Type<T>): IAction => {
  return { ...action, sender: name };
};

/**
 * The default action creator for dispatching multiple actions
 * @param actions the actions you want to dispatch
 * @param sender the class where the action gets dispatched from
 * @description devtools will show the name of the sender on the action
 * that is dispatched
 */
export const createActions = <T>(
  actions: Array<IAction>,
  { name = null }: Type<T>
): Array<IAction> => {
  return actions.map(action => ({ ...action, sender: name }));
};
